import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Mbp4aService {

  constructor(private httpService: HttpService) { }

    addMbpData(object) {
        var request = {
            URL: "mbp4a/mbpEntry",
            DATA: object
        }
        return this.httpService.post(request);
    }
    sampleDetailsRecordEntry(detailsVotingEntry) {
        var request = {
            URL: "mbp4a/detailsVotingEntry",
            DATA: detailsVotingEntry
        }
        return this.httpService.post(request);

    }

    getMbpList(object){
        var request = {  
            URL: "mbp4a/getMbpList/5cee33d225242e023acfb2d4",
            DATA: object
        }
        return this.httpService.post(request);
    }
    getMbpById(_id){
        var request = {
            URL: "mbp4a/getMBPDetailsById/" + _id,
        }
        return this.httpService.get(request);
    }
    updateMbpData(_id,object){
        var request = {
            URL: "mbp4a/updateMbpData/" + _id,
            DATA: object
        }
        return this.httpService.post(request);
    }
    deleteMbpData(_id){
        var request = {
            URL: "mbp4a/deleteMbpData/" + _id
        }
        return this.httpService.get(request);
    }
    generateMbp4aDocument(object) {
        var request = {
            URL: "mbp4a/generateMbp4aDocument",
            DATA: object
        }
        return this.httpService.post(request);
    }

    downloadMbp4aFile(id, type) {
        var token = localStorage.getItem('token')
        window.location.href = environment.pssServerUrl + "mbp4a/downloadDocument/" + id + "/" + type + "/" + token;
    }
    downloadMbp4aPdfFile(id, type) {
        var token = localStorage.getItem('token')
        window.location.href = environment.pssServerUrl + "mbp4a/downloadPdfDocument/" + id + "/" + type + "/" + token;
    }
}
